import { motion } from "framer-motion";

const PARAGRAPHS = [
    "A passionate and dedicated web developer who loves turning ideas into clean, functional, and visually appealing digital experiences. My journey into web development began back in my college days, when a simple curiosity about how websites work quickly grew into a full-blown fascination with code.",
    "Over the years, I've developed a strong focus on front-end development and expanded my skills into full-stack engineering, allowing me to bring both design and logic together. Crafting smooth interfaces with React and Next.js, styling with Tailwind, working with APIs, and building scalable backends bring me genuine joy.",
    "I also have a growing interest in AI integration to unlock new creative possibilities. Coding isn't just a skill for me, it's a craft, a passion, and a lifelong learning adventure. And I'm just getting started."
];

const containerVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            ease: "easeOut",
            staggerChildren: 0.15,
        },
    },
};

const itemVariants = {
    hidden: { opacity: 0, y: 15 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.5, ease: "easeOut" }
    },
};

export const About = () => {
    return (
        <section id="about" className="py-20 overflow-x-hidden">
            <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-80px" }}
                variants={containerVariants}
                className="flex flex-col items-center mt-8 px-4 max-w-3xl mx-auto"
            >
                {/* TITLE */}
                <motion.h2
                    variants={itemVariants}
                    className="text-3xl font-semibold text-white mb-6"
                >
                    About
                </motion.h2>

                <div className="space-y-4 text-neutral-300 text-lg sm:text-xl leading-relaxed text-left">
                    {PARAGRAPHS.map((text, index) => (
                        <motion.p
                            key={index}
                            variants={itemVariants}
                        >
                            {text}
                        </motion.p>
                    ))}
                </div>
            </motion.div>
        </section>
    );
};